import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import DashboardLayout from 'layouts/DashboardLayout';
import NumberPage from 'pages/Number/NumberPage';
import OperatorPage from 'pages/Operator/OperatorPage';
import ValuePage from 'pages/Value/ValuePage';
import RechargeDetailsPage from 'pages/RechargeDetails/RechargeDetailsPage';
import React from 'react';
import PurchaseCompletedPage from 'pages/PurchaseCompleted/PurchaseCompletedPage';

import HomePage from 'pages/Home/HomePage';

export const ROUTES_PATHS = {
  LOGGED_PAGES: {
    HOME: '/',
    NUMBER: '/number',
    OPERATOR: '/recarga/operadoras',
    VALUE: {
      CREATE: '/recarga',
      UPDATE: '/recarga/details'
    },
    PURCHASE_COMPLETED: '/recarga/compra-realizada'
  }
};

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path={ROUTES_PATHS.LOGGED_PAGES.HOME} element={<HomePage />} />
        <Route
          path="*"
          element={
            <DashboardLayout routes={ROUTES_PATHS.LOGGED_PAGES}>
              <Routes>
                <Route
                  path={ROUTES_PATHS.LOGGED_PAGES.NUMBER}
                  element={<NumberPage />}
                />
                <Route
                  path={ROUTES_PATHS.LOGGED_PAGES.OPERATOR}
                  element={<OperatorPage />}
                />
                <Route
                  path={ROUTES_PATHS.LOGGED_PAGES.VALUE.CREATE}
                  element={<ValuePage />}
                />
                <Route
                  path={ROUTES_PATHS.LOGGED_PAGES.VALUE.UPDATE}
                  element={<RechargeDetailsPage />}
                />
                <Route
                  path={ROUTES_PATHS.LOGGED_PAGES.PURCHASE_COMPLETED}
                  element={<PurchaseCompletedPage />}
                />
              </Routes>
            </DashboardLayout>
          }
        />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
